import { render, staticRenderFns } from "./MailtoLinkDialog.vue?vue&type=template&id=dd59b8b6&scoped=true&"
import script from "./MailtoLinkDialog.vue?vue&type=script&lang=js&"
export * from "./MailtoLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./MailtoLinkDialog.vue?vue&type=style&index=0&id=dd59b8b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd59b8b6",
  null
  
)

export default component.exports